module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "have-invite-code",
    class: _vm.showInviteCodeInput ? 'isOpen' : ''
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showInviteCodeInput = !_vm.showInviteCodeInput
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('haveInvitationCode')))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInviteCodeInput),
      expression: "showInviteCodeInput"
    }],
    staticClass: "form-group invite-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invitationCode),
      expression: "invitationCode",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:5|max:6'),
      expression: "'min:5|max:6'"
    }],
    class: {
      'input': true, 'danger-border': _vm.errors.has('invitationCode') || !!_vm.inviteCodeErrorMessage
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inviteCodePlaceholder'),
      "name": "invitationCode"
    },
    domProps: {
      "value": (_vm.invitationCode)
    },
    on: {
      "change": _vm.inviteChange,
      "blur": [function($event) {
        _vm.showError.invitationCode = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitationCode = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('invitationCode') && _vm.showError.invitationCode),
      expression: "errors.has('invitationCode') && showError.invitationCode"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('invitationCode')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.invitationCode),
      expression: "showError.invitationCode"
    }]
  }, [_vm._v(_vm._s(_vm.inviteCodeErrorMessage))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae0f552c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registerform/InvitationCode.vue
// module id = 1379
// module chunks = 1